import {
  Link,
  useLoaderData,
  useParams,
} from "@remix-run/react";
import clsx from "clsx";
import {
  useMemo,
  type FunctionComponent,
} from "react";

import PostItem from "~/components/Post/PostItem";
import type { loader } from "./route";
import { buttonBase } from "~/components/Common/FormStyle";
import { usePaginteData } from "~/utils/hook/usePaginteData";
import { PR_COLORS } from "~/utils/const";
import { useAuthUser } from "~/utils/hook/useIsLogin";

interface UserPostsProps {}

export const UserPosts: FunctionComponent<
  UserPostsProps
> = () => {
  const param = useParams();
  const {
    user,
    userPostsCursor: _userPostsCursor,
  } = useLoaderData<typeof loader>();

  /* const { user: authUser } = useAuthUser(); */

  const authUser = useAuthUser();
  const isMyPage = useMemo(() => {
    return authUser.user?.id === user.id;
  }, [authUser.user?.id, user.id]);

  const { nextLoad, cursor: userPosts } =
    usePaginteData(
      _userPostsCursor,
      `/user/${param.userId}/load`,
    );

  return (
    <div className={clsx()}>
      <div
        className={clsx(
          "mb-24 flex items-center justify-between",
        )}
      >
        <h3
          className={clsx(
            "text-40 font-bold",
            "max-md:text-24",
          )}
        >
          PR
        </h3>
        {isMyPage && (
          <Link
            to={"/dashboard"}
            className={clsx(
              "text-14",
              "px-20",
              "py-8",
              "border",
              "border-gray-300",
              "rounded-full",
              "hover:bg-gray-50",
              "transition-colors",
            )}
          >
            PRを書く
          </Link>
        )}
      </div>

      {userPosts.data.length === 0 && (
        <div className={clsx()}>
          <div
            className={clsx(
              "text-center",
              "text-gray-500",
            )}
          >
            投稿がありません
          </div>
        </div>
      )}

      <div className={clsx()}>
        <ul
          className={clsx(
            "grid",
            "grid-cols-3",
            "gap-16",
            "mt-24",
            "w-1300",
            "mx-auto",
            "gap-23",

            "max-md:flex",
            "max-md:flex-col",
            "max-md:gap-30",
            "max-md:w-360",
            "max-md:mr-0",
          )}
        >
          {userPosts.data
            ?.slice(0, 3)
            .map((el, i) => {
              return (
                <li key={i} className={clsx("")}>
                  <PostItem
                    color={
                      PR_COLORS[
                        i % PR_COLORS.length
                      ]
                    }
                    data={el}
                  ></PostItem>
                </li>
              );
            })}
        </ul>
      </div>
      {userPosts.data.length >= 1 && (
        <div
          className={clsx("text-center", "mt-60")}
        >
          <Link
            to={`/posts/user/${param.userId}`}
            className={clsx(
              "bg-red",
              buttonBase({
                size: "md",
                round: "full",
                variant: "default",
              }),
            )}
            onClick={() => {
              nextLoad();
            }}
          >
            もっと見る
          </Link>
        </div>
      )}
    </div>
  );
};
